<header>
  <div>
    {{ header }}
  </div>
  <icn-progressbar
    *ngIf="!editMode"
    [value]="((currentStep.stepIndex + 1) / steps.length) * 100"
    [themeColor]="themeColor"
  ></icn-progressbar>
  <icn-section-progressbar
    *ngIf="editMode"
    [currentStep]="currentStep.stepIndex"
    [headers]="wizardHeaders"
    (jumpStep)="jumpIfCan($event)"
  ></icn-section-progressbar>
</header>
<main>
  <section class="step">
    <div class="div-step">
      <div class="step-title">
        {{
          currentStep.title || (currentStep.isDoneStep ? doneTitle : stepTitle)
        }}
      </div>
      <ng-content></ng-content>
      <icn-wizard-nav
        [backHidden]="isBackHidden()"
        [nextDisabled]="isNextDisabled()"
        [nextHidden]="isNextHidden()"
        [applyDisabled]="isApplyDisabled()"
        [applyHidden]="isApplyHidden()"
        [applyState]="applyState"
        (apply)="onApply()"
        (next)="onNext()"
        (back)="onBack()"
      ></icn-wizard-nav>
    </div>
  </section>
  <section class="summary">
    <icn-wizard-summary
      [currentStepIndex]="currentStep.stepIndex"
      [themeColor]="themeColor"
    ></icn-wizard-summary>
  </section>
</main>
